module.exports = __webpack_public_path__ + "img/set_theme_13.b8ff6250.png";